import axios from "axios";
import { errorLogger } from "../helpers/functions/errorLogger";

const axiosInstance = axios.create();
const API_KEY = process.env.REACT_APP_API_KEY;

// Centralized Interceptor: Automatically attach the Authorization header if JWT exists
axiosInstance.interceptors.request.use(
  (config) => {
    const localStorageData = window.localStorage.getItem("jwt");
    if (localStorageData) {
      try {
        const parsed = JSON.parse(localStorageData);
        if (parsed.token) {
          config.headers = config.headers || {};
          
          const coreApiUrl = process.env.REACT_APP_INSTALLMENT_CORE_API_URL;
          if (!coreApiUrl || !config.url?.startsWith(coreApiUrl)) {
            config.headers["Authorization"] = parsed.token;
            config.headers["x-api-key"] = API_KEY;
          }
        }
      } catch (e) {
        // ignore parse error gracefully
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const fetch = async (url: string, params?: any, config?: any) => {
  try {
    const headers = config?.headers || {};
    return await axiosInstance.get(url, { params, headers: { ...headers } });
  } catch (err) {
    return errorLogger(err);
  }
};

export const create = async (url: string, payload: any, config?: any) => {
  try {
    
    return await axiosInstance.post(url, payload, config);
  } catch (err) {
    console.log(err, 'error');
    return errorLogger(err);
  }
};

export const update = async (url: string, payload: any, config?: any) => {
  try {
    return await axiosInstance.put(url, payload, config);
  } catch (err) {
    return errorLogger(err);
  }
};

export const search = async (url: string, params?: any, config?: any) => {
  try {
    const headers = config?.headers || {};
    return await axiosInstance.get(url, { params, headers: { ...headers } });
  } catch (err) {
    return errorLogger(err);
  }
};
